export default [
    {
        ImageUrl:
            'https://ne1.wac.edgecastcdn.net/8026C7/ShopWithScrip.com/images/dynamic/vcert/STAB002_Small_A.jpg',
        ImageName: 'STAB002_Small_A.jpg',
        ImageId: 5190,
        FaceplateId: 'DQRPNZE4',
    },
    {
        ImageUrl:
            'https://ne1.wac.edgecastcdn.net/8026C7/ShopWithScrip.com/images/dynamic/vcert/STAB002_Small_D.jpg',
        ImageName: 'STAB002_Small_D.jpg',
        ImageId: 5191,
        FaceplateId: 'DBB4DTYD',
    },
    {
        ImageUrl:
            'https://ne1.wac.edgecastcdn.net/8026C7/ShopWithScrip.com/images/dynamic/vcert/STAB002_Small_E.jpg',
        ImageName: 'STAB002_Small_E.jpg',
        ImageId: 5192,
        FaceplateId: 'DBFH5EBD',
    },
    {
        ImageUrl:
            'https://ne1.wac.edgecastcdn.net/8026C7/ShopWithScrip.com/images/dynamic/vcert/STAB002_Small_I.jpg',
        ImageName: 'STAB002_Small_I.jpg',
        ImageId: 5193,
        FaceplateId: 'D3UPPJQRP',
    },
    {
        ImageUrl:
            'https://ne1.wac.edgecastcdn.net/8026C7/ShopWithScrip.com/images/dynamic/vcert/STAB002_Small_J.jpg',
        ImageName: 'STAB002_Small_J.jpg',
        ImageId: 5194,
        FaceplateId: 'DQRPNZEH',
    },
    {
        ImageUrl:
            'https://ne1.wac.edgecastcdn.net/8026C7/ShopWithScrip.com/images/dynamic/vcert/STAB002_Small_L.jpg',
        ImageName: 'STAB002_Small_L.jpg',
        ImageId: 5195,
        FaceplateId: 'DS9KWYVY',
    },
    {
        ImageUrl:
            'https://ne1.wac.edgecastcdn.net/8026C7/ShopWithScrip.com/images/dynamic/vcert/STAB002_Small_R.jpg',
        ImageName: 'STAB002_Small_R.jpg',
        ImageId: 5196,
        FaceplateId: 'DDFESPSTH',
    },
];
